import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
  id: 'CITY_DISTRICT',
  queryKey: 'f_district',
  type: FILTER_TYPES.SEGMENTS,
  bucketify: (hotel) => {
    const bucketId = hotel?.geographical?.district?.id;
    const bucketName = hotel?.geographical?.district?.name;

    if (!bucketId || !bucketName) {
      return undefined;
    }

    return {
      bucketId,
      bucketName,
    };
  },
  // Both of these return a new object; the reducer assigns the result rather than mutating.
  onFilterValueUpdate: ({ optionId }, filterState) => {
    return {
      ...filterState,
      accordionState: { ...filterState?.accordionState, [optionId]: false },
    };
  },
  onFilterPanelClose: (filterState) => {
    const accordionState = filterState?.accordionState;
    if (!accordionState) {
      return filterState;
    }

    // The original only wrote the entries that were open. Writing every entry false reaches the
    // same state and needs no per-key check.
    const closed = {};
    Object.keys(accordionState).forEach((key) => {
      closed[key] = false;
    });

    return { ...filterState, accordionState: closed };
  },
  isFilterActive: (finalState) => {
    return Object.keys(finalState?.values || {}).length;
  },
  decorateFinalState: (finalState) => {
    // Decorate with accordionState so we can keep track of what extra information is shown
    if (finalState) finalState.accordionState = {};
    Object.keys(finalState?.values || {}).forEach((optionId) => {
      finalState.accordionState[optionId] = false;
    });
  },
  toQuery: ({ optionId, value } = {}, filterStateValues) => {
    const query = {};
    if (filterStateValues) {
      Object.entries(filterStateValues).forEach(([key, filterValue]) => {
        if (filterValue?.value) {
          query[key] = true;
        }
      });
    }

    if (optionId) query[optionId] = value;
    const res = [];

    Object.keys(query).forEach((key) => {
      if (query[key]) {
        res.push(key);
      }
    });

    return res.length ? res.join('|') : undefined;
  },
  fromQuery: (rawQueryValue) => {
    if (!rawQueryValue || typeof rawQueryValue !== 'string') {
      return false;
    }

    const optionIds = rawQueryValue.split('|');
    const res = {};

    optionIds.forEach((optionId) => {
      res[optionId] = true;
    });

    // NB: Returning false will not convert invalid input
    return res;
  },
}));
